module.exports = __webpack_public_path__ + "fonts/iconfont.44cd4e17.woff2";